import { Layouts } from 'react-grid-layout';
import DeleteStrategyAction from '../../../components/ManageStrategies/Actions/DeleteStrategyAction';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 0,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c3',
        },
        {
            h: 0,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c4',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 0,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c3',
        },
        {
            h: 0,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c4',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 0,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c3',
        },
        {
            h: 0,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c4',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        group_by: 'type',
        analysis_type: '',
        analysis_types: [
            {
                label: 'individual-strategy-creation',
                options: [
                    {
                        label: 'rule-based',
                        value: 'rule-based',
                        path: '/review-all/performance/create-strategy/rule-based',
                        ga_event_name:
                            'Performance > View strategies > Rule Based',
                    },
                    {
                        label: 'query-based',
                        value: 'query-based',
                        path: '/review-all/performance/create-strategy/query-based',
                        ga_event_name:
                            'Performance > View strategies > Query Based',
                    },
                ],
            },
            {
                label: 'bulk-strategy-creation',
                options: [
                    {
                        label: 'template-based',
                        value: 'template-based',
                        path: '/review-all/performance/create-strategy/template-based',
                        ga_event_name:
                            'Performance > View strategies > Template Based',
                    },
                ],
            },
        ],
    },
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'performance',
                    path: '/review-all/performance',
                },
                subHeader: [
                    {
                        title: 'manage-strategies',
                        path: '',
                    },
                ],
                rhsComponents: [],
            },
        },
        {
            name: 'view-strategies-table',
            key: 'c2',
            apiDetails: {
                endpoint: `strategies?`,
                endpointParams: {
                    keyword: 'keyword',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    group_by: '*,group_by',
                    types: 'group_by_filters',
                    parent_user_ids: 'parent_user_id',
                },
            },
            props: {
                requiredQueryFields: [],
                showDownloadOn: [],
                isGroupedData: true,
                showPagination: false,
                canSelectRows: true,
                filterApi: 'strategies/types',
                filterApiParams: ['user_ids'],
                filterDataKey: '',
                allMultipleRowExpand: true,
                groupInfo: {
                    groupBy: 'type',
                    fieldsToAggregate: [],
                    firstKey: 'name',
                    noGroupByText: 'All',
                },
                columns: [
                    {
                        type: 'splitCell',
                        key: 'name',
                        sticky: 'left',
                        width: 240,
                        headerText: 'ui.mm.table-headers.strategy-name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        expandRow: true,
                        canSort: true,
                    },
                    {
                        type: 'text',
                        key: 'id',
                        headerText: 'ui.table-header.strategy_id',
                        selectedByDefaultOn: [],
                    },
                    {
                        type: 'text',
                        key: 'type',
                        width: 200,
                        headerText: 'ui.table-header.strategy_type',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        type: 'object',
                        key: 'definition',
                        width: 400,
                        headerText: 'ui.table-header.strategy-definition',
                    },
                    {
                        type: 'boolean',
                        key: 'system_generated_strategy',
                        width: 200,
                        headerText:
                            'ui.mm.table-headers.system_generated_strategy',
                    },
                    {
                        key: 'parent_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                    },
                    {
                        type: 'date',
                        key: 'latest_run_at',
                        headerText: 'ui.table-header.last_run_at',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        dateFormat: '',
                        toDateFormat: 'DD MMM YYYY h:mm:ss A',
                    },
                    {
                        type: 'date',
                        key: 'createdAt',
                        headerText: 'table-headers.created-at',
                    },
                    {
                        type: 'date',
                        key: 'updatedAt',
                        headerText: 'table-headers.updated-at',
                    },
                    {
                        key: 'actions',
                        type: 'actions',
                        actions: [
                            {
                                name: 'view_strategy_transactions',
                                path: '/review-all/performance/view-strategy-transactions',
                                shouldRowBeSelected: false,
                                showOnSubTable: true,
                                showOnParentTable: false,
                                ga_event_name: 'View Strategy Transactions',
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                            {
                                name: 'delete_strategy',
                                shouldRowBeSelected: false,
                                showOnSubTable: true,
                                showOnParentTable: false,
                                Component: <DeleteStrategyAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                        headerText: 'table-headers.actions',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        ga_event_name: 'Performance > View strategies',
                    },
                ],
            },
        },
        {
            name: 'view-strategies-transactions-modal',
            key: 'c3',
            apiDetails: {
                endpoint: `strategies/transactions?`,
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    keyword: 'keyword',
                    parent_user_ids: 'parent_user_id,',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    strategy_id: '*,strategyId',
                },
            },
            props: {
                dataKey: 'transactions',
                requiredQueryFields: [],
                showDownloadOn: [],
                showFilterOn: [],
                per_page: 25,
                showBorder: false,
                noOfColumnsInSkeleton: [1, 2],

                columns: [
                    {
                        key: 'security_name',
                        otherKeys: ['ticker'],
                        width: 240,
                        type: 'splitCell',
                        sticky: 'left',
                        headerText: 'ui.table-header.name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'trade_price',
                        type: 'amount',
                        headerText: 'table-headers.price',
                    },
                    {
                        key: 'nominal_amount',
                        type: 'amount',
                        headerText: 'table-headers.qty',
                    },
                    {
                        key: 'settlement_amount_ccy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.settlement-amount',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'ticketref',
                        type: 'text',
                        headerText: 'table-headers.ticket-ref',
                        selectedByDefaultOn: [],
                    },
                    {
                        key: 'traded_on',
                        type: 'date',
                        width: 120,
                        headerText: 'table-headers.trade-date',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'settled_on',
                        type: 'date',
                        width: 120,
                        headerText: 'ui.mm.table-headers.settlement-date',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'trade_type',
                        type: 'text',
                        headerText: 'ui.table-header.trade-type',
                        width: 120,
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                    },
                    {
                        type: 'text',
                        key: 'contract_currency',
                        headerText: 'table-headers.ccy',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'custodian_name',
                        type: 'text',
                        headerText: 'table-headers.custodian',
                    },
                    {
                        key: 'parent_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                    },
                    {
                        key: 'child_username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-username',
                    },
                    {
                        key: 'ccy_account_code',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.ccy-account-code',
                    },
                    {
                        key: 'bank_narration',
                        type: 'text',
                        headerText: 'table-headers.narration',
                    },
                    {
                        key: 'related_security_name',
                        type: 'text',
                        headerText: 'ui.table-header.related-security',
                    },
                    {
                        key: 'user_asset_class',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.asset-class',
                    },
                    {
                        key: 'user_industry',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.sub-asset-class',
                    },
                    {
                        key: 'canopy_asset_class',
                        type: 'text',
                        headerText: 'ui.table-header.canopy-asset-class',
                    },
                    {
                        key: 'canopy_geography',
                        type: 'text',
                        headerText: 'ui.table-header.canopy-geography',
                    },
                ],
                ga_event_name:
                    'Performance > View strategies > View Transactions',
            },
        },
        {
            name: 'run-strategies-modal',
            key: 'c4',
            props: {
                useDatafrom: 'layoutState',
                dataKey: 'selectedStrategies',
                actionBar: false,
                showDownloadOn: [],
                showFilterOn: [],
                showColumnSelectorOn: [],
                showSearchOn: [],
                showPagination: false,
                ga_event_name: 'Performance > View strategies >Run Strategies',
                columns: [
                    {
                        key: 'id',
                        type: 'text',
                        sticky: 'left',
                        headerText: 'ui.table-header.strategy_id',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'name',
                        type: 'text',
                        headerText: 'name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'type',
                        type: 'text',
                        headerText: 'type',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'username',
                        type: 'text',
                        headerText: 'table-headers.username',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                ],
            },
        },
    ],
};
